module.exports = __webpack_public_path__ + "img/send-button.64036d7c.png";